import { commonEnums } from '../../..';
import { ServiceLines } from '../../../enums';

const {
  AccelerateProcessStatus,
  ProcessQAStatus,
  Gen2CaseStatus,
  Gen2ProcessStatus,
  HoldReasonType
} = commonEnums;

type RelatedCaseDisplayStatus = {
  chargeable: boolean;
  displayStatus: string;
  caseStatus?: string;
  processStatus?: string;
  processInstanceStatus?: string;
  qaStatus?: string;
  holdStatus?: string;
};

enum DisplayStatusLabel {
  NON_CHARGEABLE = 'Non-Chargeable',
  PREDICTED_NON_CHARGEABLE = 'Predicted Codes: Non-Chargeable',
  ERROR = 'Error',
  VOIDED = 'Voided',
  ANALYZING = 'Analyzing',
  READY_FOR_PREDICTION = 'Analyzing',
  PREDICTED = 'Analysis Complete',
  PREDICTION_FAILED = 'Analysis Complete',
  COLLECTING_DATA = 'Collecting Data',
  PREDICTED_READY_FOR_DISTRIBUTION = 'Predicted Codes: Ready for Distribution',
  PREDICTED_IN_QA = 'Predicted Codes In QA',
  PREDICTED_IN_QA_HOLD = 'Predicted Codes In QA: On Hold',
  PREDICTED_IN_QA_HOLD_DOCUMENTATION_QUERY = 'Predicted Codes In QA: On Hold - Documentation Request',
  PREDICTED_IN_QA_HOLD_MANAGER_REVIEW = 'Predicted Codes In QA: On Hold',
  PREDICTED_IN_QA_OFF_HOLD = 'Predicted Codes In QA: Off Hold',
  PREDICTED_QA_COMPLETE = 'Predicted Codes QA Complete',
  PREDICTED_CODES_RECEIVED = 'Predicted Codes Received',
  AUTOMATED = 'Sent to Billing (CMX)',
  AUTOMATED_LATE_CASE_UPDATE = 'Billed Case Updated',
  READY_FOR_DISTRIBUTION = 'Ready for Distribution',
  READY_FOR_CODING = 'Ready for Coding',
  IN_PROGRESS = 'Coding In Progress',
  HOLD = 'Coding In Progress: On Hold',
  HOLD_DOCUMENTATION_QUERY = 'Coding In Progress: On Hold - Documentation Requested',
  HOLD_MANAGER_REVIEW = 'Coding In Progress: On Hold',
  OFF_HOLD = 'Coding In Progress: Off Hold',
  IN_QA = 'Manual Codes In QA',
  QA_COMPLETE = 'Manual Codes QA Complete',
  CODER_SUBMITTED = 'Manual Coded',
  CHILD_CASE = 'Child Case',
  CASE_HAS_UPDATE = 'Case has update',
  CODER_CODES_RECEIVED = 'Manual Codes Received',
  SENT_TO_BILLING = 'Sent to Billing (Client)',
  SENT_CASE_UPDATED = 'Billed Case Updated (Client)'
}

const ipcStatusMapList: RelatedCaseDisplayStatus[] = [
  {
    chargeable: false,
    caseStatus: Gen2CaseStatus.MANUAL,
    displayStatus: DisplayStatusLabel.NON_CHARGEABLE
  },
  {
    chargeable: false,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    displayStatus: DisplayStatusLabel.PREDICTED_NON_CHARGEABLE
  },
  {
    chargeable: false,
    caseStatus: Gen2CaseStatus.CANCELLED,
    displayStatus: DisplayStatusLabel.VOIDED
  },
  {
    chargeable: false,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.CANCELLED,
    displayStatus: DisplayStatusLabel.VOIDED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.IN_PROGRESS,
    displayStatus: DisplayStatusLabel.ANALYZING
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.DATA_COLLECTED,
    displayStatus: DisplayStatusLabel.READY_FOR_PREDICTION
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.PREDICTED,
    displayStatus: DisplayStatusLabel.PREDICTED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.PREDICTION_FAILED,
    displayStatus: DisplayStatusLabel.PREDICTION_FAILED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.SENDING_TO_CODER,
    displayStatus: DisplayStatusLabel.PREDICTED_READY_FOR_DISTRIBUTION
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.AT_CODER,
    displayStatus: DisplayStatusLabel.PREDICTED_IN_QA
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.IN_QA,
    holdStatus: HoldReasonType.HOLD,
    displayStatus: DisplayStatusLabel.PREDICTED_IN_QA_HOLD
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.IN_QA,
    holdStatus: HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY,
    displayStatus: DisplayStatusLabel.PREDICTED_IN_QA_HOLD_DOCUMENTATION_QUERY
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.IN_QA,
    holdStatus: HoldReasonType.HOLD_FOR_MANAGER_REVIEW,
    displayStatus: DisplayStatusLabel.PREDICTED_IN_QA_HOLD_MANAGER_REVIEW
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.IN_QA,
    holdStatus: HoldReasonType.OFF_HOLD,
    displayStatus: DisplayStatusLabel.PREDICTED_IN_QA_OFF_HOLD
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.QA_COMPLETE,
    displayStatus: DisplayStatusLabel.PREDICTED_QA_COMPLETE
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.CODES_RECEIVED,
    displayStatus: DisplayStatusLabel.PREDICTED_CODES_RECEIVED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    processStatus: Gen2ProcessStatus.DONE,
    displayStatus: DisplayStatusLabel.ERROR
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.IN_PROGRESS,
    displayStatus: DisplayStatusLabel.COLLECTING_DATA
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.CANCELLED,
    displayStatus: DisplayStatusLabel.VOIDED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.SENDING_TO_CODER,
    displayStatus: DisplayStatusLabel.READY_FOR_DISTRIBUTION
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.NEW,
    displayStatus: DisplayStatusLabel.READY_FOR_CODING
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
    displayStatus: DisplayStatusLabel.IN_PROGRESS
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
    holdStatus: HoldReasonType.HOLD,
    displayStatus: DisplayStatusLabel.HOLD
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
    holdStatus: HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY,
    displayStatus: DisplayStatusLabel.HOLD_DOCUMENTATION_QUERY
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
    holdStatus: HoldReasonType.HOLD_FOR_MANAGER_REVIEW,
    displayStatus: DisplayStatusLabel.HOLD_MANAGER_REVIEW
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.IN_PROGRESS,
    holdStatus: HoldReasonType.OFF_HOLD,
    displayStatus: DisplayStatusLabel.OFF_HOLD
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    displayStatus: DisplayStatusLabel.CODER_SUBMITTED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.REMOVED,
    displayStatus: DisplayStatusLabel.CHILD_CASE
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.REPLACED,
    displayStatus: DisplayStatusLabel.CASE_HAS_UPDATE
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.REPLACED_CANCELLED,
    displayStatus: DisplayStatusLabel.CASE_HAS_UPDATE
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.IN_QA,
    displayStatus: DisplayStatusLabel.IN_QA
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.AT_CODER,
    processInstanceStatus: AccelerateProcessStatus.SUBMITTED,
    qaStatus: ProcessQAStatus.QA_COMPLETE,
    displayStatus: DisplayStatusLabel.QA_COMPLETE
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.CODES_RECEIVED,
    displayStatus: DisplayStatusLabel.CODER_CODES_RECEIVED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.DONE,
    displayStatus: DisplayStatusLabel.SENT_TO_BILLING
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    processStatus: Gen2ProcessStatus.DONE,
    processInstanceStatus: AccelerateProcessStatus.LATE_CASE_UPDATE,
    displayStatus: DisplayStatusLabel.SENT_CASE_UPDATED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.MANUAL,
    displayStatus: DisplayStatusLabel.ERROR
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.AUTOMATED,
    processStatus: Gen2ProcessStatus.DONE,
    displayStatus: DisplayStatusLabel.AUTOMATED
  },
  {
    chargeable: true,
    caseStatus: Gen2CaseStatus.AUTOMATED,
    processStatus: Gen2ProcessStatus.DONE,
    processInstanceStatus: AccelerateProcessStatus.LATE_CASE_UPDATE,
    displayStatus: DisplayStatusLabel.AUTOMATED_LATE_CASE_UPDATE
  }
];

const serviceLineStatusMap = {};
// this list of service line mirror the gen2 list in service-lines.ts
serviceLineStatusMap[ServiceLines.IPC] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.IPC_LONG_NAME] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.BEDSIDE_PRO] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.BEDSIDE_PRO_NO_SPACE] = ipcStatusMapList;
serviceLineStatusMap[ServiceLines.AUTOMATE] = ipcStatusMapList;

export const fieldMatch = (fieldValue, inputValue): boolean => {
  return !valueUndefined(fieldValue) && fieldValue === inputValue;
};

export const valueUndefined = fieldValue => {
  return typeof fieldValue === 'undefined' || fieldValue === null;
};

export const lookupCaseDisplayStatus = (
  serviceLine: string,
  chargeable: boolean,
  caseStatus?: string,
  processStatus?: string,
  processInstanceStatus?: string,
  qaStatus?: string,
  holdStatus?: string
) => {
  if (!serviceLineStatusMap[serviceLine]) {
    return null;
  }
  const statusMapList = serviceLineStatusMap[serviceLine];
  const tierFullMatch: RelatedCaseDisplayStatus[] = [];
  const tierQaMatch: RelatedCaseDisplayStatus[] = [];
  const tierHoldMatch: RelatedCaseDisplayStatus[] = [];
  const tierProcessInstanceStatusMatch: RelatedCaseDisplayStatus[] = [];
  const tierProcessStatusMatch: RelatedCaseDisplayStatus[] = [];
  const tierCaseStatus: RelatedCaseDisplayStatus[] = [];
  const tierChargeableMatch: RelatedCaseDisplayStatus[] = [];

  statusMapList.forEach(record => {
    if (
      fieldMatch(record.chargeable, chargeable) &&
      fieldMatch(record.caseStatus, caseStatus) &&
      fieldMatch(record.processStatus, processStatus) &&
      fieldMatch(record.processInstanceStatus, processInstanceStatus) &&
      fieldMatch(record.qaStatus, qaStatus) &&
      fieldMatch(record.holdStatus, holdStatus)
    ) {
      tierFullMatch.push(record);
    } else if (
      fieldMatch(record.chargeable, chargeable) &&
      fieldMatch(record.caseStatus, caseStatus) &&
      fieldMatch(record.processStatus, processStatus) &&
      fieldMatch(record.processInstanceStatus, processInstanceStatus) &&
      fieldMatch(record.qaStatus, qaStatus) &&
      valueUndefined(record.holdStatus)
    ) {
      tierQaMatch.push(record);
    } else if (
      fieldMatch(record.chargeable, chargeable) &&
      fieldMatch(record.caseStatus, caseStatus) &&
      fieldMatch(record.processStatus, processStatus) &&
      fieldMatch(record.processInstanceStatus, processInstanceStatus) &&
      valueUndefined(record.qaStatus) &&
      fieldMatch(record.holdStatus, holdStatus)
    ) {
      tierHoldMatch.push(record);
    } else if (
      fieldMatch(record.chargeable, chargeable) &&
      fieldMatch(record.caseStatus, caseStatus) &&
      fieldMatch(record.processStatus, processStatus) &&
      fieldMatch(record.processInstanceStatus, processInstanceStatus) &&
      valueUndefined(record.qaStatus) &&
      valueUndefined(record.holdStatus)
    ) {
      tierProcessInstanceStatusMatch.push(record);
    } else if (
      fieldMatch(record.chargeable, chargeable) &&
      fieldMatch(record.caseStatus, caseStatus) &&
      fieldMatch(record.processStatus, processStatus) &&
      valueUndefined(record.processInstanceStatus) &&
      valueUndefined(record.qaStatus) &&
      valueUndefined(record.holdStatus)
    ) {
      tierProcessStatusMatch.push(record);
    } else if (
      fieldMatch(record.chargeable, chargeable) &&
      fieldMatch(record.caseStatus, caseStatus) &&
      valueUndefined(record.processStatus) &&
      valueUndefined(record.processInstanceStatus) &&
      valueUndefined(record.qaStatus) &&
      valueUndefined(record.holdStatus)
    ) {
      tierCaseStatus.push(record);
    } else if (
      fieldMatch(record.chargeable, chargeable) &&
      valueUndefined(record.caseStatus) &&
      valueUndefined(record.processStatus) &&
      valueUndefined(record.processInstanceStatus) &&
      valueUndefined(record.qaStatus) &&
      valueUndefined(record.holdStatus)
    ) {
      tierChargeableMatch.push(record);
    }
  });
  if (tierFullMatch.length) {
    return tierFullMatch.pop().displayStatus;
  } else if (tierQaMatch.length) {
    return tierQaMatch.pop().displayStatus;
  } else if (tierHoldMatch.length) {
    return tierHoldMatch.pop().displayStatus;
  } else if (tierProcessInstanceStatusMatch.length) {
    return tierProcessInstanceStatusMatch.pop().displayStatus;
  } else if (tierProcessStatusMatch.length) {
    return tierProcessStatusMatch.pop().displayStatus;
  } else if (tierCaseStatus.length) {
    return tierCaseStatus.pop().displayStatus;
  } else if (tierChargeableMatch.length) {
    return tierChargeableMatch.pop().displayStatus;
  } else {
    return null;
  }
};
